import { Outlet } from "react-router-dom";
import { AnnouncementBar } from "./AnnouncementBar";
import { Navbar } from "./Navbar";
import { CartDrawer } from "./CartDrawer";
import { Footer } from "./Footer";
import { ScrollProgress } from "@/components/common/ScrollProgress";
import { Analytics } from "@/components/common/Analytics";

export const Layout = () => (
  <>
    <ScrollProgress />
    <AnnouncementBar />
    <Navbar />
    <CartDrawer />
    <main>
      <Outlet />
    </main>
    <Footer />
    <Analytics />
  </>
);
